
class SvTableModel {
  constructor(d, i) {
    let select = ""
    if (d.selectedTotalSubjectCnt !== d.totalSubjectCnt) {
      select = `/ ${d.selectedTotalSubjectCnt.toLocaleString()}`
    }
    this.id = d.id
    this.name = d.name
    this.selectedCancer = d.selectedCancer
    // this.subjectTotal = `${d.subjectCnt.toLocaleString()} ${select} / ${d.totalSubjectCnt.toLocaleString()}`
    this.subjectTotal = `${d.subjectCnt.toLocaleString()}`
    this.subjectCnt = d.subjectCnt
    this.sequenceAlteration = d.sequenceAlteration
    this.targetGene1Id = d.targetGene1Id
    this.targetGene2Id = d.targetGene2Id
    this.fusionSupportingRead = d.fusionSupportingRead
    this.fusionBreakpoint = d.fusionBreakpoint
    this.selectedSv = d.selectedSv
    this.checkTotal = select
  }
}

export default SvTableModel;
